import { render, staticRenderFns } from "./EditBankPhone.vue?vue&type=template&id=41ddcb56&scoped=true&"
import script from "./EditBankPhone.vue?vue&type=script&lang=js&"
export * from "./EditBankPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ddcb56",
  null
  
)

export default component.exports